module.exports = __webpack_public_path__ + "img/ylsm.a990fa33.png";